import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(public)/events/[slug]/not-found.tsx")